<template functional>
	<a @click="listeners.click(props.geoFeature)">
		<div class="geo-feature hoverable-background" @mouseenter="listeners.highlightGeometry(props.geoFeature.geoJson)"
			 @mouseleave="listeners.highlightGeometry()">
			<span class="subtitle is-5 has-text-black">{{props.geoFeature.layerDisplayName}}</span>
			<p class="has-text-grey">{{props.geoFeature.fullName | emptyName}}</p>
			<nav class="level is-mobile">
				<div class="level-left">
					<span class="level-item ">
						<a class="button is-text has-text-grey">
							<img class="icon image is-16x16" src="../../assets/svg/about_obj.svg" />
							<span class="hoverable-underline">об объекте</span>
						</a>
					</span>
					<span class="level-item has-text-grey"
						  @click.stop="listeners.toggleLayer(props.geoFeature.layerName)">
						<a v-if="!props.isLayerVisible" class="button is-text has-text-grey">
							<img src="../../assets/svg/show_layer.svg" />
							<span class="action hoverable-underline">показать слой</span>
						</a>
						<a v-else class="button is-text has-text-grey">
							<img src="../../assets/svg/hide_layer.svg" />
							<span class="action hoverable-underline">скрыть слой</span>
						</a>
					</span>
				</div>
			</nav>
		</div>
	</a>
</template>
<script>
	export default {
		props: {
			geoFeature: {
				type: Object,
				required: true
			},
			isLayerVisible: {
				type: Boolean
			}
		}
	}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	@import '../../assets/sass/main.scss';

	.geo-feature {
		border-top: 1px solid $white-ter;
		padding: 1rem 0 0.5rem 0;
	}

		.geo-feature:hover {			
			margin: 0 -1.5rem -1px;
			padding: 1rem 1.5rem calc(0.5rem + 1px);
		}

	.action {
		padding-left: 0.5rem;
	}
</style>